import React from "react";

import { Axios, AxiosError } from "axios";
import { TFunction } from "i18next";

import { toastOption } from "global/types";

import BaseLabel from "components/BaseLabel";
import Multiline from "components/Multiline";
import SimpleToast from "components/SimpleToast";

import { customerCertificateServicesV2 } from "services/customerCertificate";

import kentaLogo from "assets/kenta.svg";

import { formatDateTime } from "utils/dateTime";

import {
  ICustomerCertificateGetResponse,
  ICustomerCertificateResponse,
} from "./interface";
import {
  CertificateWrapper,
  CertificateContainer,
  LogoSection,
  InfoSection,
} from "./styles";

const TitleLabel: React.FC<{ children: string }> = ({ children }) => (
  <BaseLabel
    fontWeight="700"
    color="#44546a"
    fontSize="20px"
    marginBottom="0px"
    marginTop="0px"
    marginLeft="0px"
    marginRight="0px"
  >
    {children}
  </BaseLabel>
);

const SubTitleLabel: React.FC<{ children: string }> = ({ children }) => (
  <BaseLabel
    fontWeight="700"
    color="#000000"
    fontSize="16px"
    marginBottom="0px"
    marginTop="5px"
    marginLeft="0px"
    marginRight="0px"
  >
    {children}
  </BaseLabel>
);

const CertificateField: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <InfoSection>
    <TitleLabel>{label}</TitleLabel>
    <SubTitleLabel>{value}</SubTitleLabel>
  </InfoSection>
);

export const returnHtml = (
  t: TFunction,
  projectName: string,
  modality: string,
  amount: string,
  extraAmount: string,
  startDate: string,
  finishDate: string,
  limitRecord?: number | null,
  certificateType?: number | null,
  roomLimit?: number | null,
) => {
  return (
    <CertificateWrapper>
      <CertificateContainer>
        <LogoSection>
          <img src={kentaLogo} alt="Logo" />
          <BaseLabel
            fontWeight="700"
            color="#000000"
            fontSize="26px"
            marginTop="0px"
            marginLeft="0px"
            marginRight="0px"
            marginBottom="0px"
          >
            {projectName}
          </BaseLabel>
        </LogoSection>

        <CertificateField
          label={t("auth.certificate.modality")}
          value={modality}
        />
        <CertificateField label={t("auth.certificate.limit")} value={amount} />
        <CertificateField
          label={t("auth.certificate.extra")}
          value={extraAmount}
        />
        <CertificateField
          label={t("auth.certificate.startDate")}
          value={formatDateTime.getFullDate(new Date(startDate))}
        />
        <CertificateField
          label={t("auth.certificate.endDate")}
          value={formatDateTime.getFullDate(new Date(finishDate))}
        />

        {limitRecord !== null && limitRecord !== undefined && (
          <CertificateField
            label={t("auth.certificate.timeLimit")}
            value={
              limitRecord === 0
                ? t("auth.certificate.unlimited")
                : `${limitRecord} ${limitRecord === 1 ? t("auth.certificate.minute") : t("auth.certificate.minutes")}`
            }
          />
        )}

        {certificateType !== null && certificateType !== undefined && (
          <CertificateField
            label={t("auth.certificate.type")}
            value={
              certificateType === 1
                ? t("auth.certificate.production")
                : t("auth.certificate.test")
            }
          />
        )}

        {roomLimit !== null && roomLimit !== undefined && (
          <CertificateField
            label={t("auth.certificate.roomLimit")}
            value={
              roomLimit === 0
                ? t("auth.certificate.unlimited")
                : `${roomLimit} ${roomLimit === 1 ? t("auth.certificate.room") : t("auth.certificate.rooms")}`
            }
          />
        )}
      </CertificateContainer>
    </CertificateWrapper>
  );
};

export const textAreaComponente = (
  label: string,
  value: string,
  setValue: React.Dispatch<React.SetStateAction<string>>,
  error: boolean,
  toastTypeForm: toastOption,
  toastBodyForm: string,
  toastTriggerForm: number,
  height?: string,
) => {
  return (
    <>
      <SimpleToast
        id="attendantRoleToastId"
        title={label}
        type={toastTypeForm}
        description={toastBodyForm}
        handleCloseToast={() => {}}
        trigger={toastTriggerForm}
      />
      <Multiline
        label={label}
        name="importCertificateName"
        onChange={(e) => setValue(e)}
        value={value}
        error={error}
        required
        height={height || "410px"}
        rows={19}
      />
    </>
  );
};

export const handleApplyButton = async (api: Axios, value: string) => {
  const data: ICustomerCertificateResponse =
    await customerCertificateServicesV2.importCertificate({
      textCrypted: value,
    });

  return data;
};

export async function onLoadList(customerId: number) {
  try {
    const data =
      await customerCertificateServicesV2.getCustomerCertificateByCustomerId({
        customerId: customerId,
      });

    return data as any;
  } catch (error) {
    const errorReturn = error as AxiosError;
    const dataReturn = errorReturn.response
      ?.data as ICustomerCertificateGetResponse;
    return dataReturn;
  }
}
